<ng-container *transloco="let t; prefix: scope()">
  @if (compareCount()) {
    <div
      #anchor
      class="relative inline-flex h-full items-center"
      (pointerenter)="onPointerEnter($event)"
      (pointerleave)="onPointerLeave()"
      (focusin)="onFocusIn($event)"
      (focusout)="onFocusOut()"
    >
      <!-- The animation clips and transforms, so it wraps the button alone: with the panel inside
           it, the first add renders clipped and, being fixed, re-anchored to this element. -->
      <div
        class="inline-flex h-full items-center [--rma-count-button-width:2.5rem]"
        [animate.enter]="enterAnimation()"
        animate.leave="rma-animate-count-button-out"
      >
        <rma-header-count-button
          [title]="t('compareAgents')"
          [count]="compareCount()"
          [srSubtitle]="t('compareAgents')"
          routerLink="/account/compare-agents"
          matIcon="group"
        />
      </div>

      <rma-compare-panel
        [open]="open()"
        [agents]="agents()"
        [heading]="t('comparePanel.heading', { count: agents().length })"
        [compareLabel]="t('comparePanel.compare', { count: agents().length })"
        [removeLabel]="t('comparePanel.remove')"
        [singleHint]="t('comparePanel.single-hint')"
        [addedAgentCode]="addedAgentCode()"
        (remove)="onRemove($event)"
        (compare)="onCompare()"
      />
    </div>
  }
</ng-container>
